import Vue from 'vue';

import {i18n} from '../../plugins/i18n';

Vue.mixin({
  methods: {
    i18nLink(path = null) {
      let i18nLink = this.coreParams.multi_language && +this.coreParams.multi_language ? `/${i18n.locale}` : '';

      if (path && path !== '/') {
        return `${i18nLink}${this._.first(path) === '/' ? '' : '/'}${path}`;
      }

      return i18nLink === '' ? '/' : i18nLink;
    },
  },
});
